// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Btj1","video-icon":"_1_4A-","title":"_19KXk","player":"_1jdYd"};